import { api } from '@/lib/api'

export interface DashboardSummary {
  total_companies: number
  total_projects: number
  active_projects: number
  total_contract_value: number
  total_actual_cost: number
  total_paid_amount: number
  total_boq_sections: number
  total_boq_value: number
}

export interface ProjectByStatus {
  status: string
  count: number
  total_value: number
}

export interface ProjectByType {
  type: string
  count: number
  total_value: number
}

export interface ProjectProgress {
  id: number
  code: string
  name: string
  name_ar?: string | null
  progress: number
  contract_value: number
  currency: string
  status: string
}

export interface DashboardStats {
  summary: DashboardSummary
  projects_by_status: ProjectByStatus[]
  projects_by_type: ProjectByType[]
  projects_progress: ProjectProgress[]
}

export const dashboardApi = {
  getStats: async (): Promise<DashboardStats> => {
    const { data } = await api.get<DashboardStats>('/dashboard/stats')
    return data
  },
}